export const _LOAD_SHAPE_MODEL_ = 'Load:ShapePuzzle';
export const _SAVE_SHAPE_MODEL_ = 'Save:ShapePuzzle';

export const SHAPES = {
  circle: { tag: 'circle' },
  square: { tag: 'rect' },
  diamond: { tag: 'polygon', points: '12,3 21,12 12,21 3,12' },
  triangle: { tag: 'polygon', points: '12,3 22,21 2,21' },
  pentagon: { tag: 'polygon', points: '12,2 22,8.5 18,20 6,20 2,8.5' },
  hexagon: { tag: 'polygon', points: '12,2 21,7 21,17 12,22 3,17 3,7' },
  star: { tag: 'polygon', points: '12,2 15,9 22,9 16,14 18,21 12,17 6,21 8,14 2,9 9,9' },
  triangle_down: { tag: 'polygon', points: '2,3 22,3 12,21' },
  octagon: { tag: 'polygon', points: '8,2 16,2 22,8 22,16 16,22 8,22 2,16 2,8' },
};

export const DIRECTION_SIDES = {
  h: {
    top: false,
    right: true,
    bottom: false,
    left: true,
  },
  v: {
    top: true,
    right: false,
    bottom: true,
    left: false,
  },
  tr: {
    top: true,
    right: true,
    bottom: false,
    left: false,
  },
  tl: {
    top: true,
    right: false,
    bottom: false,
    left: true,
  },
  br: {
    top: false,
    right: true,
    bottom: true,
    left: false,
  },
  bl: {
    top: false,
    right: false,
    bottom: true,
    left: true,
  },
};

export const PATH_WEIGHTS = {
  thin: 1.2,
  normal: 2,
  bold: 4,
};

export const CELL = {
  id: null,
  positionx: 0,
  positiony: 0,
  shape: null,
  value: null,
  filled: true,
  color: null,
  direction: null,
};

export const SETTINGS = {
  showAnswer: true,
  shapeMode: 'geometric',
  filled: 'filled',
  numberStyle: 'circle',
  colored: false,
  autoPairs: true,
  num_pairs: null,
  pathWeight: 'normal',
};

export const MODEL = {
  id: null,
  name: null,
  slug: null,
  type_id: 4,
  rows: 10,
  columns: 10,
  settings: { ...SETTINGS },
  table: [],
};

export const CELL_SIZE = 60;
